import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "percentage", "fixedAmount"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.selectorTarget.value

    if (type === "percentage") {
      this.percentageTarget.classList.remove("hidden")
      this.fixedAmountTarget.classList.add("hidden")
    } else {
      this.percentageTarget.classList.add("hidden")
      this.fixedAmountTarget.classList.remove("hidden")
    }
  }
}
